// extracted by mini-css-extract-plugin
export default {"inputHolder":"ChatbotHelpMessages_inputHolder__lovz6"};